<div class="modal-header">
  <h4 class="modal-title">{{ pageTitle }}</h4>
  <a
    [href]="attachment.url"
    class="download-btn px-1 btn btn-light"
    target="_blank"
    title="Download file"
  >
    <i class="fas fa-download"></i>
  </a>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="activeModal.dismiss('')"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div *ngIf="validFile">
    <div
      class="d-flex justify-content-center"
      *ngIf="attachment.type.indexOf('image') != -1"
    >
      <img
        [src]="attachment.url"
        style="width: 65vw; height: 100%; object-fit: contain"
        class="img-fluid img-thumbnail"
      />
    </div>
    <div class="row">
      <div class="col-md-12" *ngIf="attachment.type.indexOf('image') == -1">
        <ngx-doc-viewer
          [url]="attachment.url"
          viewer="google"
          style="width: 100%; height: 80vh"
        ></ngx-doc-viewer>
      </div>
    </div>
  </div>
  <div *ngIf="!validFile">
    <div class="d-flex justify-content-center py-5 my-5">
      <h2>NO PREVIEW</h2>
    </div>
  </div>
</div>
<div class="modal-footer"> </div>
